//
// A class to help with benchmarking code.
function ANBenchmarker(logger){

    this.__data   = {};
    this.__logger = logger;
}

/**
 * Starts a timer and returns a unique id.
 * 
 * @param string methodName 
 * @returns 
 */
ANBenchmarker.prototype.startTimer = function(methodName){

    var uniqueId          = crypto.randomUUID();
    this.__data[uniqueId] = {
        methodName: methodName,
        startTime: performance.now(),
        endTime: null,
    };

    return uniqueId;
};

/**
 * Stops a timer.
 * 
 * @param string uniqueId 
 */
ANBenchmarker.prototype.stopTimer = function(uniqueId){

    this.__data[uniqueId].endTime = performance.now();

    this.__logger.info(`Benchmark: ${this.__data[uniqueId].methodName} took ${this.__data[uniqueId].endTime - this.__data[uniqueId].startTime}ms!`);
};

ANBenchmarker.prototype.calculateAverageCompletionTime = function(){
    
    var totals = {};

    for(var uniqueId in this.__data){

        var data = this.__data[uniqueId];

        if(!data.endTime){

            continue;
        }

        if(!totals[data.methodName]){

            totals[data.methodName] = {
                total: 0,
                count: 0
            };
        }

        totals[data.methodName].total += data.endTime - data.startTime;
        totals[data.methodName].count += 1;
    }

    for(var methodName in totals){

        this.__logger.info(`Benchmark: Average completion time for ${methodName} is ${totals[methodName].total / totals[methodName].count}ms after ${totals[methodName].count} runs!`);
    }
}

window.ANBenchmarker = ANBenchmarker;